import { State } from '@meraki-internal/state';
import { ILiveUpdatesService } from './ILiveUpdatesService.tsx';
import pkg from '../../../package.json' with { type: 'json' };

export class WebLiveUpdatesService extends State<{}> implements ILiveUpdatesService  {
    constructor(){
        super({});
    }

    getActualVersion = () => {
        const shortSha = (process.env.VITE_APP_SHA || '(no sha)').substring(0,7);
        return `${pkg.version}.${shortSha}`;
    };

    getInstalledVersion = () => this.getActualVersion();

    init = async () => {
        // do nothing
    };
    downloadUpdateIfAvailable = async () => {
        // do nothing
    };
    installOrDownloadUpdateIfAvailable = async () => {
        // do nothing
    };

    showManagerLink = () => false;

    mustWaitForLatestUpdate = async () => false;

    waitForDownloadAndInstall = async () => {
        // do nothing
    };
}
